export default "__VITE_ASSET__BZ5hE9SN__"